export default "__VITE_ASSET__BHQ47Zin__"